import {
    IconeInicio, IconeAgenda, IconeContratos, IconeProcessos,
    IconePrazos, IconePagamentos, IconeClientes
} from "./icones";

/* Fonte única das seções do app — usada pela barra do topo (desktop) e pela
   barra inferior (mobile). `curto` é o rótulo enxuto da barra inferior. */
export const SECOES = [
    { rota: "/inicio", rotulo: "Início", curto: "Início", Icone: IconeInicio, principal: true },
    { rota: "/agenda", rotulo: "Agenda", curto: "Agenda", Icone: IconeAgenda, principal: true },
    { rota: "/contratos", rotulo: "Contratos", curto: "Contratos", Icone: IconeContratos, principal: true },
    { rota: "/processos", rotulo: "Processos", curto: "Processos", Icone: IconeProcessos },
    { rota: "/prazos", rotulo: "Prazos", curto: "Prazos", Icone: IconePrazos },
    { rota: "/pagamentos", rotulo: "Pagamentos", curto: "Pagtos.", Icone: IconePagamentos },
    { rota: "/clientes", rotulo: "Clientes", curto: "Clientes", Icone: IconeClientes, principal: true }
];
